import api from "../../../api/api";

export const savePdfVersion = (body) => api.post("/pdf-versions", body);

export const listPdfVersions = (tc_id) =>
  api.get("/pdf-versions", { params: { tc_id } });

export const getPdfVersion = (id) =>
  api.get(`/pdf-versions/${encodeURIComponent(id)}`);

export const updatePdfVersionName = (id, body) =>
  api.patch(`/pdf-versions/${encodeURIComponent(id)}`, body);

export const deletePdfVersion = (id) =>
  api.delete(`/pdf-versions/${encodeURIComponent(id)}`);

export const deleteAllPdfVersions = (tc_id) =>
  api.delete("/pdf-versions/all", { params: { tc_id } });
